export default __webpack_public_path__ + "static/media/33-AfterTheStorm.d3ad4bf8.jpeg";